/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeClockAuditCtrl
 */
angular.module('mercury.modules.time.clock')
.controller('TimeClockAuditCtrl', ["$q", "$uibModal", "$resource", "$scope", "title", "settings", function($q, $uibModal, $resource, $scope, title, settings) {
  title.set('Timeclock Edit History');

  var ClockinHistory = $resource(settings.mercHost + '/time/clockins/histories');

  $scope.operationFilter = null;
  $scope.operationFilterOptions = [
    {label: 'Created', value: 'Created'},
    {label: 'Updated', value: 'Updated'},
    {label: 'Deleted', value: 'Deleted'}
  ];

  $scope.startTime = null;
  $scope.endTime = null;

  $scope.filterUpdate = function() {
    //Signal the pagedTable directive to update.
    $scope.$broadcast('dataTableUpdate');
  };

  $scope.clockHistory = [];
  $scope.totalCount = 0;

  $scope.getPage = function(tableParams) {
    var filter = [];

    if ($scope.operationFilter) {
      filter.push('Operation eq \'' + $scope.operationFilter + '\'');
    }

    if ($scope.startTime) {
      filter.push('DatestampUpdated gt ' + $scope.startTime);
    }

    if ($scope.endTime) {
      filter.push('DatestampUpdated lt ' + $scope.endTime);
    }

    var params = {
      $count: 'true',
      $top: tableParams.limit,
      $skip: tableParams.limit * (tableParams.page - 1),
      $orderby: tableParams.order + ' ' + ((tableParams.desc) ? 'desc' : 'asc')
    };

    if (filter.length > 0) {
      params.$filter = filter.join(' and ');
    }

    $scope.loading = ClockinHistory.get(params).$promise;
    $scope.loading.then(function(history) {
      $scope.totalCount = history.__count;
      $scope.clockHistory = history.results;
    });

  };

  $scope.clearFilter = function() {
    $scope.startTime = null;
    $scope.endTime = null;
    $scope.operationFilter = null;

    $scope.filterUpdate();
  };

  $scope.showHistory = function(clockinHistory) {
    $uibModal.open({
      templateUrl: 'modules/time/clock/popupaudit.tpl.html',
      controller: 'TimeClockPopupauditCtrl',
      resolve: {
        clockinId: function() {
          return clockinHistory.clockinId;
        }
      }
    });
  };
}]);
